<template>
  <div style="background-color: #f6f8fa">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pt-2>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex v-for="(card, index) in cards" :key="index" xs12 md4 sm4 lg3 pa-2  @pointerenter="onPointerEnter($event, index)" @pointerleave="onPointerLeave($event)">
            <v-card elevation="2" rounded="xl"
              :class="['colorful-card', 'card-' + (index), { 'colorful-card--hovered': hoveredCard === index }]">
              <v-layout wrap justify-center>
                <v-flex xs12 pa-3 pa-sm-4>
                  <v-layout wrap align-center>
                    <v-flex xs1 lg1 class="d-flex align-center">
                      <div class="card-vert-bar"></div>
                    </v-flex>
                    <v-flex xs8 lg8>
                      <v-layout wrap justify-end>
                        <v-flex xs12 class="text-start"><span class="detailshead">{{
                          card.title
                            }}</span></v-flex>
                        <v-flex xs12 class="text-start value" pt-1>{{
                          card.value
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 lg3 class="text-right align-self-center">
                      <v-icon size="38" class="card-icon">{{ card.icon }}</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap justify-end pt-2>
                    <v-flex xs12 class="text-end">
                      <span>
                        <span class="colorful-action-link" @click="redirectToPage(card.action, card.title)">{{
                          card.action }}
                          <span>
                            <v-icon small class="action-arrow">mdi-arrow-right</v-icon></span></span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start>
      <v-flex xs12>
        <v-layout wrap justify-start style="align-items: stretch;">
          <v-flex xs12 lg6 style="display:flex; flex-direction:column;">
            <v-layout wrap justify-start style="flex:1; height:100%;">
              <v-flex xs12 pa-3 style="display:flex; flex-direction:column;">
                <v-card elevation="2" rounded="xl" class="chart-premium-card"
                  style="flex:1; display:flex; flex-direction:column;">
                  <v-layout wrap justify-start pa-5>
                    <v-flex xs12>
                      <v-layout wrap justify-start align-center>
                        <v-flex xs12 lg8>
                          <span class="chart-card-title">
                            <v-icon color="#6366F1" size="24" class="mr-2">mdi-chart-bar</v-icon>
                            Total Cases
                          </span>
                        </v-flex>
                        <v-flex xs12 lg4 class="pt-2 pt-lg-0">
                          <v-select outlined dense :hide-details="true" :items="yearitems" v-model="lineyeardata"
                            class="chart-year-select"></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-4>
                      <v-layout wrap justify-start>
                        <v-flex xs12 v-if="flag1">
                          <highcharts :options="histogramOptions"></highcharts>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <v-skeleton-loader type="image" height="400" class="rounded-lg"></v-skeleton-loader>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 lg6 style="display:flex; flex-direction:column;">
            <v-layout wrap justify-center style="flex:1; height:100%;">
              <v-flex xs12 pa-3 style="display:flex; flex-direction:column;">
                <v-card elevation="2" rounded="xl" class="chart-premium-card"
                  style="flex:1; display:flex; flex-direction:column;">
                  <v-layout wrap justify-center pa-5>
                    <v-flex xs12>
                      <v-layout wrap justify-center>
                        <v-flex xs12 class="text-center">
                          <span class="chart-card-title">
                            <v-icon color="#E91E63" size="24" class="mr-2">mdi-snake</v-icon>
                            Top 10 Common Snake Species {{ currentYear }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-6>
                      <v-layout wrap justify-start>
                        <v-flex xs12 v-if="flag">
                          <highcharts :options="highchartsOptions" :constructor-type="'chart'"></highcharts>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <v-skeleton-loader type="image" height="344" class="rounded-lg"></v-skeleton-loader>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-2 v-if="flag">
                      <v-layout wrap justify-center>
                        <v-flex xs12 class="text-center">
                          <span class="colorful-action-link"
                            style="color: #E91E63 !important; background: rgba(233,30,99,0.08);"
                            @click="redirectToSnakeDetails()">
                            View Details <v-icon small color="#E91E63">mdi-arrow-right</v-icon>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout wrap justify-start pt-4>
          <v-flex xs12 pa-3>
            <v-card elevation="2" rounded="xl" class="rescuer-main-card">
              <v-layout wrap justify-start pa-5>
                <v-flex xs12>
                  <v-layout wrap justify-start>
                    <v-flex xs12 pa-2>
                      <span class="reportone" style="display: flex; align-items: center;">
                        <v-icon color="#E91E63" size="32" class="mr-3">mdi-trophy-variant</v-icon>
                        Top Rescuers of the Year {{ currentYear }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pt-4>
                  <v-layout wrap justify-start>
                    <v-flex xs12 sm4 md4 lg4 v-for="(item, index) in topusers" :key="index" class="px-2 pb-4">
                      <div class="rescuer-item" :class="'rescuer-item--' + (index + 1)" style="cursor: pointer;" @click="item && item.user && redirectToRescuerDashboard(item.user._id)">
                        <div class="rescuer-rank" :class="'rank-' + (index + 1)">#{{ index + 1 }}</div>
                        <div class="rescuer-info" style="min-width: 0;">
                          <div v-if="item && item.user && item.user.name" class="rescuername">
                            {{ item.user.name }}
                          </div>
                          <div class="rescuervalue-badge mt-2" :class="'badge-rank-' + (index + 1)">
                            <span v-if="item && item.user && item.count">
                              {{ item.count }} <v-icon small color="white" class="ml-1">mdi-snake</v-icon>
                            </span>
                            <span v-else>0</span>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-if="topusers && topusers.length > 0">
                  <v-layout wrap justify-end>
                    <v-flex xs12 pa-3 class="text-end">
                      <span class="colorful-action-link"
                        style="color: #6366F1 !important; background: rgba(99, 102, 241, 0.1);"
                        @click="redirectToUsersDetails()">
                        View More <v-icon small color="#6366F1">mdi-arrow-right</v-icon>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 align-self-start pl-4 v-if="topusers && topusers.length === 0">
                  <span class="reporttwo">No data available!</span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
    </v-layout>
    <v-layout wrap justify-center>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    const currentDate = new Date();

    //new year wise graph
    const currentYear = new Date().getFullYear();
    const dynamicYears = [];
    for (let y = currentYear; y >= 2015; y--) {
      dynamicYears.push(y);
    }

    const currentMonth = currentDate.toLocaleString("default", {
      month: "long",
    });
    return {
      hoveredCard: null,
      currentYear,
      currentMonth,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pages: 0,
      count: 20,
      pendingRequests: 0,
      cards: [
        {
          title: "Total Users",
          value: 0,
          action: "View Map",
          icon: "mdi-account-circle",
          vert: require("@/assets/images/redvertical.png"),
          color: "green",
        },
        {
          title: "Snake Rescuers",
          value: 0,
          action: "View Map",
          icon: "mdi-shield-star",
          vert: require("@/assets/images/purplevert.png"),
          color: "blue",
        },
        {
          title: "Snakes Rescued",
          value: 0,
          action: "View Map",
          icon: "mdi-snake",
          vert: require("@/assets/images/yellowvert.png"),
          color: "red",
        },
        {
          title: "Identification Help",
          value: 0,
          action: "View Details",
          icon: "mdi-card-search",
          vert: require("@/assets/images/bluevert.png"),
          color: "yellow",
        },
        {
          title: "Snake Deaths",
          value: 0,
          action: "View Details",
          icon: "mdi-alert-octagon",
          vert: require("@/assets/images/greyvert.png"),
          color: "yellow",
        },
        {
          title: "Listed Hospitals",
          value: 0,
          action: "View Map",
          icon: "mdi-hospital-box",
          vert: require("@/assets/images/greenvert.png"),
          color: "red",
        },
        {
          title: "Public Users",
          value: 0,
          action: "View Details",
          icon: "mdi-account-multiple",
          vert: require("@/assets/images/orangevert.png"),
          color: "purple",
        },
        {
          title: "Listed Snakes",
          value: 0,
          action: "View Details",
          icon: "mdi-view-list",
          vert: require("@/assets/images/pinkvert.png"),
          color: "light-green",
        },
        {
          title: "Total Reports",
          value: 0,
          action: "View Details",
          icon: "mdi-file-document-multiple",
          vert: require("@/assets/images/bluevert.png"),
          color: "indigo",
        },
        {
          title: "Report Rescued",
          value: 0,
          action: "View Details",
          icon: "mdi-hand-heart",
          vert: require("@/assets/images/greenvert.png"),
          color: "teal",
        },
        {
          title: "Snakes Escaped",
          value: 0,
          action: "View Details",
          icon: "mdi-run",
          vert: require("@/assets/images/orangevert.png"),
          color: "orange",
        },
      ],
      dates: [],
      details: [
        { title: "Most Common Snakes - 2024", icon: "mdi-snake" },
        { title: "Top Rescuers of July", icon: "mdi-snake" },
        { title: "Top Rescuers of 2024", icon: "mdi-snake" },
      ],
      topsnakes: [],
      topusers: [],
      chartOptions3: {
        chart: {
          height: 262,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xAxis: {
          categories: [], // This will be populated with year data
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
      },
      series3: [
        {
          name: "Count",
          data: [],
        },
      ],
      yearitems: dynamicYears,
      lineyeardata: currentYear,
      options: {
        chart: {
          type: "donut",
        },
        labels: [], // For the animal names
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series: [],
      flag: false,
      flag1: false,
      yearwiseData: [],
      histogramOptions: {
        chart: {
          type: "column", // Change to 'column' for histogram
          height: 400,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [], // This will be populated with year data
          title: {
            text: "Month",
          },
        },
        credits: {
          enabled: false, // Disable the Highcharts watermark
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total Cases",
          },
        },
        plotOptions: {
          column: {
            pointWidth: 30, // Set the width of the columns (adjust this value)
            dataLabels: {
              enabled: true, // Enable data labels if needed
              formatter: function () {
                return this.y.toLocaleString(); // Automatically adds commas based on locale
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            data: [], // This will be populated with values from yearData
            color: "#00E096",
          },
        ],
        exporting: {
          enabled: false, // Disable the export menu
        },
      },
      highchartsOptions: {
        chart: {
          type: "pie",
          height: 344,
        },
        credits: {
          enabled: false, // Disable the Highcharts watermark
        },
        title: {
          text: null,
          enabled: true,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}</b>", // Show count instead of percentage
        },
        accessibility: {
          point: {
            valueSuffix: "",
          },
        },
        exporting: {
          enabled: false, // Disable the export menu
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            borderRadius: 1,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return (
                  "<b>" +
                  this.point.name.charAt(0).toUpperCase() +
                  this.point.name.slice(1).toLowerCase() +
                  "</b>: " +
                  this.point.y // Display count instead of percentage
                );
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            colorByPoint: true,
            data: [], // Data will be dynamically populated
          },
        ],
      },
      seriesData: [],
    };
  },
  beforeMount() {
    this.pendingRequests = 3;
    this.appLoading = true;
    this.countData();
    this.yearData();
    this.topsnakesData();
  },
  watch: {
    lineyeardata() {
      this.yearData();
    },
  },
  methods: {
    onPointerEnter(event, index) {
      if (event.pointerType === "mouse") {
        this.hoveredCard = index;
      }
    },
    onPointerLeave(event) {
      if (event.pointerType === "mouse") {
        this.hoveredCard = null;
      }
    },
    redirectToSnakeDetails() {
      this.$router.push({ path: "/officers/topcommonsnakes" });
    },
    topsnakesData() {
      axios({
        method: "GET",
        url: "/topsnakes/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          currentyear: this.currentYear,
        }
      })
        .then((response) => {
          if (response.data.status == true) {
            const animalReportSummary = response.data.data.allSnakes;
            const seriesData = animalReportSummary.map((item) => ({
              name: item.snakeName,
              y: item.count,
            }));
            // Deep-replace so Highcharts detects reactivity
            this.$set(this.highchartsOptions.series[0], 'data', seriesData);
            this.flag = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        })
        .finally(() => {
          this.pendingRequests--;
          if (this.pendingRequests <= 0) this.appLoading = false;
        });
    },
    redirectToPage(action, title) {
      if (title === "Total Users") {
        this.$router.push({ path: "/officers/usermap" });
      } else if (title === "Snake Rescuers") {
        this.$router.push({ path: "/officers/rescuermap" });
      } else if (title === "Snakes Rescued") {
        this.$router.push({ path: "/officers/snakerescued" });
      } else if (title === "Identification Help") {
        this.$router.push({ path: "/officers/identificationhelp" });
      } else if (title === "Listed Hospitals") {
        this.$router.push({ path: "/officers/hospitalMap" });
      } else if (title === "Snake Deaths") {
        this.$router.push({ path: "/officers/snakebiteDeath" });
      } else if (title === "Listed Snakes") {
        this.$router.push({ path: "/officers/listedSnakes" });
      } else if (title === "Public Users") {
        this.$router.push({ path: "/officers/usersList" });
      } else if (title === "Total Reports") {
        this.$router.push({ path: "/officers/snakereports" });
      } else if (title === "Report Rescued") {
        this.$router.push({ path: "/officers/snakereports" });
      } else if (title === "Snakes Escaped") {
        this.$router.push({ path: "/officers/snakereports" });
      }
    },

    redirectToUsersDetails() {
      this.$router.push({ path: "/officers/topUsers" });
    },
    redirectToUsersyearDetails() {
      this.$router.push({ path: "/officers/topUsersyear" });
    },
    redirectToRescuerDashboard(id) {
      if (id) {
        this.$router.push({ path: "/officers/rescuerDashboard/" + id });
      }
    },
    countData() {
      axios({
        method: "GET",
        url: "/user/stats",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.cards[0].value = response.data.data.count_total_users;
            this.cards[1].value = response.data.data.count_total_rescuer;
            this.cards[2].value = response.data.data.count_total_locations;
            this.cards[3].value = response.data.data.count_identify;
            this.cards[4].value = response.data.data.count_management;
            this.cards[5].value = response.data.data.count_hospital;
            this.cards[6].value = response.data.data.count_users;
            this.cards[7].value = response.data.data.count_snakes;
            this.cards[8].value = response.data.data.count_total_reports;
            this.cards[9].value = response.data.data.count_report_rescued;
            this.cards[10].value = response.data.data.count_snake_escaped;
            this.topsnakes = response.data.data.topsnakes;
            this.topusers = response.data.data.topusers;
            // Note: flag (pie chart) is owned by topsnakesData — do not set it here
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        })
        .finally(() => {
          this.pendingRequests--;
          if (this.pendingRequests <= 0) this.appLoading = false;
        });
    },

    //new year wise graph
    yearData() {
      const selectedYear = this.lineyeardata;

      if (this.pendingRequests <= 0) {
        this.pendingRequests = 1;
        this.appLoading = true;
        this.flag1 = false;
      }

      axios({
        method: "GET",
        url: "/user/monthwise",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: selectedYear,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            const monthData = response.data.data;
            // Map months (Jan, Feb, Mar, etc.) to the X-axis
            this.$set(this.histogramOptions.xAxis, 'categories', monthData.map((item) => item.month));
            // Map the counts to the chart columns
            this.$set(this.histogramOptions.series[0], 'data', monthData.map((item) => item.count));
            this.flag1 = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        })
        .finally(() => {
          this.pendingRequests--;
          if (this.pendingRequests <= 0) this.appLoading = false;
        });
    },

  },
};
</script>
<style>
/* Enhanced Colorful Cards with Modern Transitions */
.colorful-card {
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1) !important;
  color: #f8fafc !important;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 22px !important;
  backdrop-filter: blur(14px) saturate(180%);
  -webkit-backdrop-filter: blur(14px) saturate(180%);
  box-shadow: 0 8px 32px 0 rgba(15, 23, 42, 0.12), inset 0 1px 1px 0 rgba(255, 255, 255, 0.2) !important;
  background-size: 150% 150% !important;
  background-position: left center !important;
}

/* Shimmer sweep on hover */
.colorful-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.15), transparent);
  transition: left 0.55s ease;
  pointer-events: none;
}

/* ── Vertical accent bar ─────────────────────────── */
.card-vert-bar {
  width: 4px;
  height: 38px;
  border-radius: 4px;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  background: rgba(255, 255, 255, 0.45);
}

/* Card 0: Emerald → Teal Theme */
.colorful-card.card-0 {
  background: linear-gradient(135deg, rgba(15, 118, 110, 0.8), rgba(20, 184, 166, 0.8)) !important;
  border: 1px solid rgba(20, 184, 166, 0.25) !important;
}
.colorful-card.card-0 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-0.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(20, 184, 166, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(20, 184, 166, 0.5) !important;
}

/* Card 1: Royal Blue → Indigo Theme */
.colorful-card.card-1 {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.8), rgba(79, 70, 229, 0.8)) !important;
  border: 1px solid rgba(79, 70, 229, 0.25) !important;
}
.colorful-card.card-1 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-1.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(79, 70, 229, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(79, 70, 229, 0.5) !important;
}

/* Card 2: Crimson → Rose Red Theme */
.colorful-card.card-2 {
  background: linear-gradient(135deg, rgba(220, 38, 38, 0.8), rgba(239, 68, 68, 0.8)) !important;
  border: 1px solid rgba(239, 68, 68, 0.25) !important;
}
.colorful-card.card-2 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-2.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(239, 68, 68, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(239, 68, 68, 0.5) !important;
}

/* Card 3: Amber → Orange Theme */
.colorful-card.card-3 {
  background: linear-gradient(135deg, rgba(217, 119, 6, 0.8), rgba(245, 158, 11, 0.8)) !important;
  border: 1px solid rgba(245, 158, 11, 0.25) !important;
}
.colorful-card.card-3 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-3.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(245, 158, 11, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(245, 158, 11, 0.5) !important;
}
/* Card 4: Black Theme (Total Reports) */
.colorful-card.card-4 {
  background: linear-gradient(135deg, rgb(45, 45, 45), rgba(12, 12, 12, 0.8)) !important;
  border: 1px solid rgba(213, 237, 58, 0.25) !important;
}
.colorful-card.card-4 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-4.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(28, 28, 27, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(31, 31, 28, 0.5) !important;
}

/* Card 5: Pink → Magenta Theme */
.colorful-card.card-5 {
  background: linear-gradient(135deg, rgba(219, 39, 119, 0.8), rgba(236, 72, 153, 0.8)) !important;
  border: 1px solid rgba(236, 72, 153, 0.25) !important;
}
.colorful-card.card-5 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-5.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(236, 72, 153, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(236, 72, 153, 0.5) !important;
}

/* Card 6: Purple → Violet Theme */
.colorful-card.card-6 {
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.8), rgba(139, 92, 246, 0.8)) !important;
  border: 1px solid rgba(139, 92, 246, 0.25) !important;
}
.colorful-card.card-6 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-6.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(139, 92, 246, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(139, 92, 246, 0.5) !important;
}

/* Card 7: Teal → Cyan Theme */
.colorful-card.card-7 {
  background: linear-gradient(135deg, rgba(15, 118, 110, 0.8), rgba(6, 182, 212, 0.8)) !important;
  border: 1px solid rgba(6, 182, 212, 0.25) !important;
}
.colorful-card.card-7 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-7.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(6, 182, 212, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(6, 182, 212, 0.5) !important;
}

/* Card 8: Slate Blue → Steel Gray Theme */
.colorful-card.card-8 {
  background: linear-gradient(135deg, rgba(71, 85, 105, 0.8), rgba(100, 116, 139, 0.8)) !important;
  border: 1px solid rgba(148, 163, 184, 0.25) !important;
}
.colorful-card.card-8 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-8.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(100, 116, 139, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(148, 163, 184, 0.5) !important;
}

/* Card 9: Dark Teal Theme (Report Rescued) */
.colorful-card.card-9 {
  background: linear-gradient(135deg, rgba(29, 148, 13, 0.947), rgba(50, 212, 45, 0.8)) !important;
  border: 1px solid rgba(45, 212, 191, 0.25) !important;
}
.colorful-card.card-9 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-9.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(45, 212, 191, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(45, 212, 191, 0.5) !important;
}

/* Card 10: Orange Theme (Snakes Escaped) */
.colorful-card.card-10 {
  background: linear-gradient(135deg, rgba(234, 88, 12, 0.8), rgba(249, 115, 22, 0.8)) !important;
  border: 1px solid rgba(249, 115, 22, 0.25) !important;
}
.colorful-card.card-10 .card-vert-bar {
  background: rgba(255, 255, 255, 0.55) !important;
}
.colorful-card.card-10.colorful-card--hovered {
  box-shadow: 0 16px 40px rgba(249, 115, 22, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(249, 115, 22, 0.5) !important;
}

/* Common Interactive Features */
.colorful-card--hovered {
  transform: translateY(-6px) scale(1.015);
  z-index: 10;
  background-position: right center !important;
}
.colorful-card--hovered::after {
  left: 160%;
}
.colorful-card--hovered .card-vert-bar {
  height: 48px;
  background: rgba(255, 255, 255, 0.8) !important;
}
.colorful-card--hovered .card-icon {
  transform: scale(1.08);
  filter: drop-shadow(0 2px 12px rgba(255, 255, 255, 0.35));
  opacity: 1;
}
.colorful-card .colorful-action-link:hover {
  transform: translateX(4px);
}

/* Card Typography */
.colorful-card .detailshead {
  color: rgba(248, 250, 252, 0.75) !important;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: 0.2px;
}
.colorful-card .value {
  color: #f8fafc !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
}

/* Card Icons */
.colorful-card .card-icon {
  color: rgba(255, 255, 255, 0.8) !important;
  filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.12));
  opacity: 0.85;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Modern pill action button with glass effect */
.colorful-action-link {
  font-size: 11px;
  cursor: pointer;
  font-family: poppinsmedium, sans-serif;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.12) !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  color: #f8fafc !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.colorful-card .action-arrow {
  color: rgba(248, 250, 252, 0.8) !important;
  margin-left: 4px;
  transition: all 0.3s ease;
}
.colorful-action-link:hover {
  background: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.colorful-action-link:hover .action-arrow {
  color: #ffffff !important;
  transform: translateX(2px);
}

/* Original Styles Restored */
.detailshead {
  font-family: poppinsregular;
  font-size: 14px;
  font-weight: 800;
  line-height: 18px;
}

.value {
  font-family: poppinsregular;
  font-size: 25px;
  font-weight: 700;
  line-height: 18px;
}

.listvalue {
  font-family: poppinsbold;
  font-size: 14px;
}

.sarpa {
  font-family: poppinsmedium;
  font-size: 20px;
  font-weight: 500px;
}

.viewmore {
  font-family: poppinsregular;
  font-size: 13px;
  text-decoration: underline;
}

.reportone {
  font-family: poppinsregular;
  font-size: 18px;
  font-weight: 600;
  line-height: 32px;
}

.rescuername {
  font-family: poppinsregular;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
}

.rescuervalue {
  font-family: poppinsregular;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  color: #58d062;
}

.viewdetails {
  font-family: poppinsregular;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #20b659;
  text-decoration: underline;
  cursor: pointer;
}

.reporttwo {
  font-family: poppinsregular;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: rgba(0, 0, 0, 1);
  color: #797979;
}

/* Enhanced Top Rescuers Section */
.rescuer-main-card {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  background: #ffffff !important;
  transition: all 0.4s ease;
}

.rescuer-main-card:hover {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.06) !important;
}

/* Rescuer card — per-rank left border accent */
.rescuer-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f8fafc;
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-left: 4px solid #e2e8f0;
  cursor: pointer;
  height: 100%;
  min-height: 80px;
}

.rescuer-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.09);
  background: #ffffff;
}

/* Rank-based left-border + hover glow */
.rescuer-item--1 {
  border-left-color: #FFD700;
}

.rescuer-item--1:hover {
  box-shadow: 0 10px 24px rgba(255, 215, 0, 0.2);
}

.rescuer-item--2 {
  border-left-color: #90CAF9;
}

.rescuer-item--2:hover {
  box-shadow: 0 10px 24px rgba(33, 150, 243, 0.15);
}

.rescuer-item--3 {
  border-left-color: #FFAB76;
}

.rescuer-item--3:hover {
  box-shadow: 0 10px 24px rgba(230, 81, 0, 0.15);
}

.rescuer-item--4,
.rescuer-item--5,
.rescuer-item--6 {
  border-left-color: #818CF8;
}

.rescuer-item--4:hover,
.rescuer-item--5:hover,
.rescuer-item--6:hover {
  box-shadow: 0 10px 24px rgba(99, 102, 241, 0.12);
}

.rescuer-rank {
  font-weight: 800;
  font-size: 15px;
  color: #94A3B8;
  margin-right: 14px;
  min-width: 28px;
  font-family: poppinsbold;
}

.rescuer-rank.rank-1 {
  color: #FFD700;
  font-size: 20px;
  text-shadow: 0 2px 8px rgba(255, 215, 0, 0.5);
}

.rescuer-rank.rank-2 {
  color: #90CAF9;
  font-size: 18px;
}

.rescuer-rank.rank-3 {
  color: #FFAB76;
  font-size: 16px;
}

.rescuer-info {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
}

.rescuer-item .rescuername {
  font-family: poppinsmedium;
  font-size: 14px;
  color: #1E293B;
  font-weight: 600;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  margin-bottom: 6px;
}

/* Badge colours per rank */
.rescuervalue-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  color: white !important;
  padding: 3px 12px;
  border-radius: 20px;
  font-family: poppinsbold;
  font-size: 13px;
  transition: all 0.3s ease;
}

.badge-rank-1 {
  background: linear-gradient(135deg, #FFD700, #FFA000);
  box-shadow: 0 3px 10px rgba(255, 215, 0, 0.4);
}

.badge-rank-2 {
  background: linear-gradient(135deg, #90CAF9, #1976D2);
  box-shadow: 0 3px 10px rgba(33, 150, 243, 0.3);
}

.badge-rank-3 {
  background: linear-gradient(135deg, #FFAB76, #E65100);
  box-shadow: 0 3px 10px rgba(230, 81, 0, 0.3);
}

.badge-rank-4,
.badge-rank-5,
.badge-rank-6 {
  background: linear-gradient(135deg, #818CF8, #4338CA);
  box-shadow: 0 3px 10px rgba(99, 102, 241, 0.3);
}

.rescuer-item:hover .rescuervalue-badge {
  transform: scale(1.06);
}

/* Premium Chart Cards */
.chart-premium-card {
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  transition: all 0.45s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04) !important;
}

.chart-premium-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.12) !important;
  border-color: rgba(99, 102, 241, 0.15) !important;
}

.chart-card-title {
  font-family: poppinsmedium, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1E293B;
  display: flex;
  align-items: center;
}

/* Year Select - Modern Style */
.chart-year-select .v-input__slot {
  border-radius: 10px !important;
  background: #F8FAFC !important;
  border-color: rgba(99, 102, 241, 0.2) !important;
}

.chart-year-select.v-text-field--outlined.v-input--is-focused .v-input__slot {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}
</style>
